// Row meta and read-only field text for the mobile Dashboards list and
// editor (mobile overhaul Phase D §13). The list row reads
// "…/mrg · upd 3 Sep" and the editor's Phase row "02 · Shoot · Active";
// both are pure string maths, so they live here rather than in the pages.

import { formatDayMonth } from './calendar';

/** "…/mrg" — the public URL with the host elided (mockup §13.1 A). */
export function dashboardShortUrl(slug: string): string {
  return `…/${slug}`;
}

/** "upd 3 Sep" from the manifest's generated_at timestamp; "—" when it has
    never been published. */
export function dashboardUpdatedLabel(generatedAt: string | null | undefined): string {
  if (!generatedAt) return '—';
  return `upd ${formatDayMonth(generatedAt.slice(0, 10))}`;
}

/** "…/mrg · upd 3 Sep" — the whole row meta line. */
export function dashboardRowMeta(slug: string, generatedAt: string | null | undefined): string {
  return `${dashboardShortUrl(slug)} · ${dashboardUpdatedLabel(generatedAt)}`;
}

const PHASE_STATUS_LABEL: Record<string, string> = {
  completed: 'Done',
  active: 'Active',
  pending: 'Pending',
};

/** "02 · Shoot · Active" — position in the fixed four-phase ladder, the
    phase's label, and the manifest's own status for it (Active when the
    manifest doesn't carry one, since it is the current phase). */
export function dashboardPhaseLine(
  phases: readonly { key: string; label: string }[],
  currentPhase: string | null | undefined,
  status?: string | null,
): string {
  const idx = phases.findIndex((p) => p.key === currentPhase);
  if (idx === -1) return '—';
  const num = String(idx + 1).padStart(2, '0');
  return `${num} · ${phases[idx].label} · ${PHASE_STATUS_LABEL[status ?? 'active'] ?? 'Active'}`;
}
